export default __webpack_public_path__ + "static/media/Integraties.a7ecfa51.svg";